module.exports = __webpack_public_path__ + "static/media/kariba_logo.5e65b157.svg";